// src/pages/Swap/components/SwapActions.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isNativeToken } from '../utils/SwapUtils';

/**
 * SwapActions component handles the swap/approve buttons and their states
 */
const SwapActions = ({
  // Token data
  inputToken,
  outputToken,
  inputTokenBalance,
  
  // Amount data
  amountIn,
  
  // Approval states
  needsApproval,
  isCheckingApproval,
  isApproving,
  
  // Loading states
  isLoading,
  isSwapping,
  
  // Action handlers
  onApproveToken,
  onPrepareSwap,
  onRefreshApproval,
  
  // Wrap/Unwrap states
  isWrapUnwrap = false,
  wrapUnwrapType = null
}) => {
  const { t } = useTranslation();
  
  // Determine if swap button should be disabled
  const isSwapDisabled = 
    isLoading ||
    isApproving ||
    isSwapping ||
    !inputToken.symbol ||
    !outputToken.symbol ||
    !amountIn ||
    parseFloat(amountIn) <= 0 ||
    parseFloat(amountIn) > parseFloat(inputTokenBalance) ||
    (needsApproval && !isWrapUnwrap) ||
    isCheckingApproval;
  
  // Determine if approve button should be disabled
  const isApproveDisabled = 
    isLoading ||
    isApproving ||
    isSwapping ||
    !inputToken.symbol ||
    !outputToken.symbol ||
    !amountIn ||
    parseFloat(amountIn) <= 0 ||
    parseFloat(amountIn) > parseFloat(inputTokenBalance) ||
    isCheckingApproval ||
    isNativeToken(inputToken.address);
  
  // Get the appropriate button text based on operation type
  const getButtonText = () => {
    if (isSwapping) {
      if (isWrapUnwrap) {
        return wrapUnwrapType === 'wrap' ? "Wrapping..." : "Unwrapping...";
      }
      return t('swap.swapping');
    }
    
    if (isWrapUnwrap) {
      return wrapUnwrapType === 'wrap' ? "Wrap" : "Unwrap";
    }
    
    return t('swap.swap');
  };
  
  return (
    <div className="swap-button-container">
      {/* Show approval button only for regular swaps that need approval */}
      {needsApproval && !isNativeToken(inputToken.address) && !isWrapUnwrap ? (
        <div className="approval-container">
          <button 
            className="approve-btn"
            onClick={onApproveToken}
            disabled={isApproveDisabled}
          >
            {isApproving 
              ? t('swap.approving') 
              : t('swap.approve', { token: inputToken.symbol })}
          </button>
        </div>
      ) : (
        <button 
          className={`swap-btn ${isWrapUnwrap ? 'wrap-btn' : ''}`}
          onClick={onPrepareSwap}
          disabled={isSwapDisabled}
        >
          {getButtonText()}
        </button>
      )}
    </div>
  );
};

export default SwapActions;